export class Akamai {
  static addParams = ({
    image,
    width,
    color,
    bypassCors,
    impolicy = undefined,
  }: {
    image: string
    width: number
    color: string
    bypassCors?: boolean
    impolicy?: string | undefined
  }) => {
    const slicePoint = image && image.indexOf('?')
    let imageUrl = image

    let imPolicy = ''
    if (impolicy) {
      imPolicy = impolicy
    } else {
      imPolicy = this.evaluateImpolicy(imageUrl)
    }

    // If the url contain '?' char
    if (slicePoint && slicePoint !== -1 && image) {
      // Remove previous query string params from img URL
      imageUrl = image.slice(0, slicePoint)
    }

    // Add query string updated params to tell
    // the width and eventually the color to Akamai

    const queryString = color
      ? `?impolicy=${imPolicy}&width=${width}&bgc=%23${color}`
      : `?impolicy=${imPolicy}&width=${width}`

    const replacedUrl = imageUrl ? imageUrl.concat(queryString) : ''

    let url = replacedUrl

    if (bypassCors) {
      url = `${replacedUrl}&differentUrl=true`
    }

    return url
  }

  private static evaluateImpolicy(imageUrl: string) {
    if (imageUrl?.includes('RB_Product_small')) {
      return 'RB_Product_small'
    }
    if (imageUrl?.includes('PACK')) {
      return 'RB_Product'
    }
    return 'RB_Product_clone'
  }
}
